export const environment = {
  production: true,
  apiUrl: 'https://sky-erp-integration.middleware.sky/suppliersearch/api/suppliers',
  appUrl: 'https://sky.supplier.middleware.sky',
  authority: 'https://login.microsoftonline.com/68b865d5-cf18-4b2b-82a4-a4eddb9c5237',
  clientId: '77f9660c-d2ca-4229-8af4-bd9c8761758b',
  apiScope: 'api://9ab6ce7b-4ef5-4bfd-9da3-b9577ef516ac/access_as_user'
};
